/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import Person from '@material-ui/icons/Person';
import Assessment from '@material-ui/icons/Assessment';
import PieChart from '@material-ui/icons/PieChart';
import WorkOff from '@material-ui/icons/WorkOff';
import BusinessCenter from '@material-ui/icons/BusinessCenter';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CallIcon from '@material-ui/icons/Call';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import PeopleIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import AddBoxIcon from '@material-ui/icons/AddBox';
import TrendingUp from '@material-ui/icons/TrendingUp';
import CodeIcon from '@material-ui/icons/Code';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import DetailsIcon from '@material-ui/icons/Details';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import {
  Assignment,
  Bookmark,
  Bookmarks,
  Chat,
  EmojiPeople,
  ExpandLess,
  ExpandMore,
  FormatAlignLeft,
} from '@material-ui/icons';
import ListItemLink from './ListItemLink';
import { MainContext } from '../../../context/ApiContext';
import ContactsIcon from '@material-ui/icons/Contacts';
import AssignmentIcon from '@material-ui/icons/Assignment';

export const MainListItems = ({ newUsers }) => {
  const [open, setOpen] = React.useState(false);
  const [user, setUser] = useState();
  const {
    auth: { getUserInfo },
  } = useContext(MainContext);

  useEffect(() => {
    getUserInfo().then((res) => setUser(res.data));
  }, []);

  const handleClick = () => {
    setOpen(!open);
  };

  // id	name
  // 1	admin
  // 2	gerente_corretora
  // 3	corretor
  // 4	gerente_concessionaria
  // 5	indicador
  // 6	renovacao

  return (
    <List
      style={{
        overflowY: 'auto',
        maxHeight: '100vh',
        overflowX: 'hidden',
      }}>
      <ListItemLink icon={<DashboardIcon />} text={user && user.roles[0].id < 4 ? 'Dashboard' : 'Indicação'} to="/" />
      {user && user.roles[0].id < 4 && (
        <>
          <ListItemLink icon={<BusinessCenter />} text="Criar Lead" to="/lead" />
        </>
      )}
      {user && user.roles[0].id === 3 && (
        <ListItemLink icon={<BusinessCenter />} text="Me Indico" to="/auto-indicação" />
      )}
      {user && user.roles[0].id === 1 && (
        <>
          <ListItemLink icon={<BusinessCenter />} text="Me Indico" to="/auto-indicação" />
          <ListItemLink count={newUsers} icon={<Person />} text="Usuários" to="/users" />
          <ListItemLink icon={<ContactsIcon />} text="Clientes" to="/clients" />
          {/* <ListItemLink icon={<DashboardIcon />} text="Esteira do Cliente" to="/esteira-cliente" /> */}

          {/* <ListItem button onClick={handleClick}>
            <ListItemIcon>
              <AddBoxIcon />
            </ListItemIcon>
            <ListItemText text="Cadastros Básicos" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List>
              <ListItemIcon style={{ marginLeft: '16px', color: '#898989' }}>
                <ArrowDropDownIcon />
              </ListItemIcon>
            </List>
          </Collapse> */}
          <ListItemLink icon={<PeopleIcon />} text="Equipe Técnica" to="/technical-team" />
          <ListItemLink icon={<SettingsIcon />} text="Lead Corretor Config" to="/lead-broker-config" />
          <ListItemLink icon={<PieChart />} text="Rel. Ind. Corretora" to="/relatorio-indicacoes-corretora" />
          <ListItemLink icon={<LibraryBooksIcon />} text="Rel. Ind. Conce." to="/relatorio-indicacoes-concessionaria" />
          <ListItemLink icon={<CallIcon />} text="Rel. de Ligações" to="/relatorio-ligacoes" />
          <ListItemLink icon={<WatchLaterIcon />} text="Rel. de Atendimento" to="/relatorio-atendimento" />
          <ListItemLink icon={<WorkOff />} text="Rel. de Perdas" to="/relatorio-perdas" />
          <ListItemLink icon={<RecentActorsIcon />} text="Indicação Externa" to="/indicacao-externa" />
          {/* <ListItemLink icon={<DetailsIcon />} text="Funil de vendas" to="/funnel-charts" /> */}
          <ListItemLink icon={<CodeIcon />} text="Verificação de Leads" to="/conferencia-informacoes-lead" />
          <ListItemLink icon={<TrendingUp />} text="Rel. Vendas Quiver" to="/relatorio-vendas-quiver" />
          {/* <ListItemLink icon={<AssignmentIcon />} text="Rel. Processamentos" to="/relatorio-processamentos" /> */}
          <ListItemLink icon={<AssignmentIcon />} text="Rel. Renovações" to="/relatorio-renovacoes" />
          <ListItemLink icon={<EmojiPeople />} text="Rel. Presencial" to="/relatorio-diagnostico-presencial" />
          <ListItemLink icon={<Bookmarks />} text="Rel. Leads Duplicados" to="/relatorio-leads-duplicados" />
          <ListItemLink icon={<FormatAlignLeft />} text="Rel. Origem" to="/relatorio-leads-origem" />
          <ListItemLink icon={<Chat />} text="ChatBot" to="/chat-bot" />
          {/* <ListItemLink icon={<AssignmentIcon />} text="Rel. Diag. Renovacões" to="/relatorio-diagnostico" /> */}
          {/* <ListItemLink icon={<LibraryBooksIcon />} text="Rel. Diag. Novos" to="/relatorio-novos-seguros" /> */}
        </>
      )}
      {user && (user.roles[0].id == 5 || user.roles[0].id == 7) && (
        <>
          <ListItemLink icon={<Assessment />} text="Rel. Indicador" to="/relatorio-indicador" />
          <ListItemLink icon={<RecentActorsIcon />} text="Indicação Externa" to="/indicacao-externa" />
        </>
      )}
      {user && user.roles[0].id == 3 && (
        <>
          <ListItemLink icon={<AssignmentIcon />} text="Rel. Renovações" to="/relatorio-renovacoes" />
        </>
      )}
      {user && (user.roles[0].id == 2 || user.roles[0].id == 3) && (
        <>
          <ListItemLink icon={<PieChart />} text="Rel. Ind. Corretora" to="/relatorio-indicacoes-corretora" />
          <ListItemLink icon={<LibraryBooksIcon />} text="Rel. Ind. Conce." to="/relatorio-indicacoes-concessionaria" />
          <ListItemLink icon={<WorkOff />} text="Rel. de Perdas" to="/relatorio-perdas" />
          <ListItemLink icon={<CallIcon />} text="Rel. de Ligações" to="/relatorio-ligacoes" />
          <ListItemLink icon={<ContactsIcon />} text="Clientes" to="/clients" />
          <ListItemLink icon={<CodeIcon />} text="Verificação de Leads" to="/conferencia-informacoes-lead" />
        </>
      )}
      {user && user.roles[0].id === 4 && (
        <ListItemLink icon={<LibraryBooksIcon />} text="Rel. Ind. Conce." to="/relatorio-indicacoes-concessionaria" />
      )}
    </List>
  );
};
